import React from 'react';
import { NavLink } from 'react-router-dom';
import { Layers, BarChart2, Crown, History, LogOut } from 'lucide-react';
import { useAuth } from '../auth/useAuth';
import { fetchOverview } from '../api';

function NavItem({ icon, label, to }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `w-full flex items-center gap-3 px-4 py-3 rounded-[10px] text-[15px] font-medium transition-all duration-200 ${
          isActive
            ? 'bg-[#8c3af0] text-white shadow-md shadow-purple-900/20'
            : 'text-gray-400 hover:text-white hover:bg-white/5'
        }`
      }
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}

export default function Sidebar() {
  const { logout, session } = useAuth();
  const [user, setUser] = React.useState({ name: 'Loading...', username: '...' });

  React.useEffect(() => {
    fetchOverview()
      .then(res => {
        if (res?.data?.user) {
          setUser(res.data.user);
        }
      })
      .catch(err => {
        console.error("Failed to load user details in Sidebar", err);
        setUser({ name: 'Unknown User', username: '' });
      });
  }, []);

  return (
    <aside className="w-[260px] bg-[#111625] text-gray-300 flex flex-col justify-between h-full">
      <div className="overflow-y-auto">
        <div className="p-6 pb-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-purple-500 rounded flex items-center justify-center shrink-0">
              <Layers className="text-white w-5 h-5" />
            </div>
            <div>
              <h1 className="text-white font-serif font-bold text-xl tracking-wide">Miggus</h1>
            </div>
          </div>
          <div className="mt-2 text-[11px] text-gray-400 font-mono tracking-wider">Billing Portal</div>
        </div>

        <div className="px-6 py-4 border-b border-gray-800 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-purple-900/60 flex items-center justify-center text-purple-200 font-bold shrink-0">
            {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="overflow-hidden">
            <div className="text-white font-medium text-sm truncate">{user.name}</div>
            <div className="text-[12px] text-gray-400 mt-0.5 truncate">{user.username}</div>
          </div>
        </div>

        <nav className="p-4 space-y-1 mt-2">
          <NavItem to="/" icon={<BarChart2 className="w-[18px] h-[18px]" />} label="Overview" />
          <NavItem to="/plans" icon={<Crown className="w-[18px] h-[18px]" />} label="Plans" />
          <NavItem to="/history" icon={<History className="w-[18px] h-[18px]" />} label="Payment History" />
        </nav>
      </div>

      <div className="border-t border-gray-800 p-4">
        <button
          type="button"
          onClick={logout}
          className="flex w-full items-center gap-3 rounded-[10px] px-4 py-3 text-[15px] font-medium text-gray-400 transition-all duration-200 hover:bg-white/5 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-400"
        >
          <LogOut className="h-[18px] w-[18px]" aria-hidden="true" />
          <span>Log out</span>
          {session?.username && <span className="sr-only">{session.username}</span>}
        </button>
      </div>
    </aside>
  );
}
